import routes from './routes';

export const home = {
  externalLinks: [
    {
      title: 'Cambridge Assessment public website',
      description:
        'An international exams group designing and delivering assessments to over 8 million learners in over 170 countries.',
      url: 'https://www.cambridgeassessment.org.uk/',
    },
    {
      title: 'Cambridge University Press',
      description:
        "Cambridge University Press is the publishing house of the University of Cambridge. Dedicated to excellence, its purpose is to further the University's ob­jective of advancing knowledge, education, learning, and research worldwide.",
      url: 'https://www.cambridge.org/',
    },
    {
      title: 'Interchange',
      description:
        'Cambridge OCR Interchange is a free, secure website for centres which offers a variety of services for exams officers and teachers. These range from the ability to carry out day-to-day administrative functions online quickly and efficiently to accessing Active Results, free results analysis portal.',
      url: 'https://interchange.ocr.org.uk/',
    },
    {
      title: 'School Support Hub',
      description:
        'The School Support Hub is Cambridge International’s secure online site for teachers at Cambridge International Schools.  Teachers can log in to find all the support they need to teach Cambridge International  programmes in one easy place. There are 30 000 high-quality teaching and learning resources on the School Support Hub, including schemes of work, example candidate responses, past papers and learner guides.',
      url: 'https://auth.schoolsupporthub.cambridgeinternational.org/',
    },
  ],
  internalLinks: [
    {
      title: 'Request Sumo Logic Access',
      description:
        'Gain access to the internal dashboard to see stats about your application users.',
      url: 'https://cambridgeorg.sharepoint.com/:u:/r/sites/Connect/SitePages/Accessing-Sumo-Logic.aspx?csf=1&web=1&e=fiZbdH',
    },
  ],
};

export const account = {
  navigationCards: [
    {
      title: routes.PersonalInfo.name,
      description:
        'Edit your personal information, like your name, email addresses and password.',
      buttonText: 'Manage personal info',
      path: routes.PersonalInfo.path,
    },
    {
      title: routes.Communications.name,
      description:
        'Manage what emails and messages you receive, and when. Use this section to unsubscribe to all communications.',
      buttonText: 'Manage communication preferences',
      path: routes.Communications.path,
    },
    {
      title: routes.ConnectedAccounts.name,
      description:
        'Connect and disconnect accounts that you use to sign in to My Cambridge, such as Google, Facebook, or Linkedin.',
      buttonText: 'Manage connected accounts',
      path: routes.ConnectedAccounts.path,
    },
  ],
};

export const contactUs = {
  externalLinks: [
    {
      title: 'Contact Cambridge University Press',
      description:
        'Get help with Cambridge checkout, Cambridge One, Cambridge Go, and more.',
      url: 'https://www.cambridge.org/about-us/contact-us',
    },
    {
      title: 'Contact OCR',
      description:
        'Get help with OCR Qualifications, Teach Cambridge, and more.',
      url: 'https://www.ocr.org.uk/contact-us/',
    },
    {
      title: 'Contact Cambridge Assessment English',
      description:
        'Get help with Cambridge Assessment English qualifications, global listening, and more.',
      url: 'https://www.cambridgeenglish.org/help/',
    },
    {
      title: 'Contact Cambridge Assessment International Education',
      description:
        'Get help with Cambridge International qualifications, School Support Hub, Grade Transcript service, and more.',
      url: 'https://help.cambridgeinternational.org/hc/en-gb/requests/new?ticket_form_id=53542',
    },
    {
      title: 'Contact Cambridge Assessment Admissions Testing',
      description:
        'Get help with admissions tests, the CPSQ service, and more.',
      url: 'https://support.admissionstesting.org/',
    },
  ],
};
